import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { BENCHMARK_PEER_LABEL } from 'pages/pga-coach/dashboard/performance-benchmarks/constants'
import { TopCoachesLink } from 'pages/pga-coach/dashboard/performance-benchmarks/top-coaches-definition'
import BenchmarkScaleTrack, {
  BenchmarkScaleTick,
} from 'pages/pga-coach/dashboard/performance-benchmarks/benchmark-scale-track'
import {
  formatBenchmarkValue,
  getDetailScalePercent,
} from 'pages/pga-coach/dashboard/performance-benchmarks/utils'

// Below this gap (percent of the track) the centered peer label would run into
// the "Getting started" label, so only its tick is shown; the value is above.
const MIN_PEER_LABEL_GAP_PERCENT = 30

const BenchmarkScale = ({ metric, classes, cohortSize }) => {
  const gettingStartedPercent = getDetailScalePercent(
    metric.gettingStartedValue,
    metric,
  )
  const medianPercent = getDetailScalePercent(metric.medianValue, metric)
  const top10Percent = getDetailScalePercent(metric.top10Value, metric)
  const showPeerLabel =
    medianPercent - gettingStartedPercent >= MIN_PEER_LABEL_GAP_PERCENT

  return (
    <Box className={classes.scaleSection}>
      <Box className={classes.metricValueRow}>
        <Typography className={classes.metricValue}>
          {formatBenchmarkValue(metric.coachValue, metric.unit)}
        </Typography>
        <Box className={classes.scaleValuesRow}>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>
              <TopCoachesLink cohortSize={cohortSize}>
                {BENCHMARK_PEER_LABEL}
              </TopCoachesLink>
            </Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.medianValue, metric.unit)}
            </Typography>
          </Box>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>Top 10%</Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.top10Value, metric.unit)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <BenchmarkScaleTrack metric={metric} className={classes.scaleTrack}>
        <BenchmarkScaleTick percent={gettingStartedPercent} />
        <BenchmarkScaleTick percent={medianPercent} />
        <BenchmarkScaleTick percent={top10Percent} />
      </BenchmarkScaleTrack>

      <Box className={classes.scaleLabelsRow}>
        <Typography
          className={classes.scaleLabel}
          style={{ left: `${gettingStartedPercent}%` }}
        >
          Getting started
        </Typography>
        {showPeerLabel && (
          <Typography
            className={`${classes.scaleLabel} ${classes.scaleLabelCenter}`}
            style={{ left: `${medianPercent}%` }}
          >
            <TopCoachesLink cohortSize={cohortSize}>
              {BENCHMARK_PEER_LABEL}
            </TopCoachesLink>
          </Typography>
        )}
        <Typography
          className={`${classes.scaleLabel} ${classes.scaleLabelEnd}`}
          style={{ left: `${top10Percent}%` }}
        >
          Top 10%
        </Typography>
      </Box>
    </Box>
  )
}

BenchmarkScale.propTypes = {
  metric: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  cohortSize: PropTypes.number,
}

export default BenchmarkScale
